import React from 'react';

import VideoPlayer from './../blogComponents/SimpleVideoPlayer';


function BioVideo(props) {
  const {
    promoVideo,
    anchor,
    promoThumbnail,
    user,
  } = props;

  const showPromoVideo = promoVideo && (anchor.active || anchor.guest);

  if (!showPromoVideo && !promoThumbnail) {
    return null;
  }

  if (showPromoVideo) {
    return (
      <div className="col-md-6 com-sm-12 col-xs-12 anchor-fan-zone-free-video">
        <VideoPlayer
          clip={{ videoUrl: promoVideo, imageUrl: promoThumbnail }}
          fanZoneFreeVideo={true}
          user={user}
        />
      </div>
    );
  }

  return (
    <div className="col-md-6 com-sm-12 col-xs-12 anchor-fan-zone-free-video">
      <img
        alt="Fan Zone Promo"
        className="anchor-bio-right-side-image"
        src={promoThumbnail}
      />
    </div>
  );
}

export default BioVideo;
